import './FSapp.css';
import SiteProjectStatusWidget from './reporting-widgets/SiteProjectStatusWidget';

export default function SiteProjectStatus() {
  const siteId = parseInt(sessionStorage.getItem('siteId') || '', 10) || 0;

  return <SiteProjectStatusWidget siteId={siteId} />;
}